import axios from 'axios';
import { axiosInstance, storageAxiosInstance } from '../axiosInstance';

const adminStorageInfo = {
  url: {
    presignedURLIssue: '/api/v1/crs-file-object/presignedurl/issue',
    search: 'api/v1/crs-file-storage/search',
    upload: 'storage/v2/crs-file-storage/object',
  },
};

export const storageFileSearch = (sid: string) => {
  const { url } = adminStorageInfo;

  console.log(axiosInstance.defaults.baseURL);
  storageAxiosInstance.defaults.baseURL = axiosInstance.defaults.baseURL;

  return storageAxiosInstance.post(url.search, {
    cmd: '1307',
    sid: sid,
  });
};

// {
//     "strid": "UCWORKS.user.default.kr.v2",
//     "provider": "UCWORKS",
//     "purpose": "user",
//     "region": "kr",
//     "ver": "v2",
//     "bucket": "default",
//     "endpoint": "https://ucwarejp-storage.schoolline.jp/storage",
//     "updatetime": "20250107090339478"
// }

export const storageFilePost = ({
  strid,
  relsvcname,
  relkey,
  endpoint,
  file,
}: {
  strid: string;
  relsvcname: string;
  relkey: string;
  endpoint: string;
  file: File;
}) => {
  const { url } = adminStorageInfo;
  const jwtToken = sessionStorage.getItem('jwtToken');

  const queryParams = new URLSearchParams({
    strid,
    relsvcname,
    relkey,
    fileid: generateUUID32(),
  }).toString();

  const formData = new FormData();

  console.log('file---', file);
  formData.append('file', file);
  const response = axios.put(`${endpoint}${'/v2/crs-file-storage/object'}?${queryParams}`, formData, {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  });

  //   const response = storageAxiosInstance.post(`${url.upload}?${queryParams}`, formData);
  return response;
};

export const presignedImageRequest = (file: File, url: string) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = axios.put(url, formData);

  return response;
};

export const presignedURLIssue = ({
  sid,
  relkey,
  tenantid,
  fileid,
  operation,
}: {
  tenantid: string;
  sid: string;
  relkey: string;
  fileid: string;
  operation: string;
}) => {
  const { url } = adminStorageInfo;
  storageAxiosInstance.defaults.baseURL = axiosInstance.defaults.baseURL;
  const body = {
    cmd: '1303',
    sid: sid,
    relsvcname: 'note',
    relkey: relkey,
    operation: operation,
    expires: 3600,
    usertenantid: tenantid,
    country: 'KR',
    what: [
      {
        filedir: '',
        filename: 'channel_logo',
        filesize: 1180,
        // fileid: generateUUID32(),
        fileid: fileid,
        filetenantid: tenantid,
        strid: 'UCWORKS.user.default.kr.v2',
      },
    ],
  };

  return storageAxiosInstance.post(url.presignedURLIssue, body);
};

export const generateUUID32 = (): string => {
  return crypto.randomUUID().replace(/-/g, '');
};
